module.exports = __webpack_public_path__ + "static/media/ss_VANQUISH.a8aabc5f.png";